<template>
  <div class="pagination">
    <el-pagination
      small
      :page-size="pageSize"
      :current-page.sync="current"
      layout="prev, pager, next"
      :hide-on-single-page="true"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>

import { GET_FEEDS} from "../../store/actions/feeds";
  /*
   pagination component based on element ui pagination
  */
export default {
  name: "Pagination",
  props: {
    feeds: {
      type: Array,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    meta: {
      type: Number,
      required: false
    }
  },
  computed: {
    current: {
      get () {
        return this.currentPage;
      },
      set (value) {
        this.$emit("currentChange", value);
        if (value != this.currentPage) this.$store.dispatch(GET_FEEDS, value)
      },
    },
    total() {
      return this.meta
    }
  }
};
</script>

<style>
.pagination {
  clear: both;
}
</style>
